import React, { useState } from 'react';
import { motion } from 'framer-motion';

import { PageMeta } from '../../components';

const c = {
  teal: '#1A9E85',
  tealDark: '#157A68',
  tealLight: 'rgba(26,158,133,0.1)',
  tealBorder: 'rgba(26,158,133,0.25)',
  navy: '#0F2033',
  text: '#1B2B3A',
  textMid: '#4A5E6E',
  textLight: '#7A8C99',
  white: '#FFFFFF',
  bg: '#F5F9FC',
  border: '#DDE7EE',
};

const fadeUp = {
  hidden: { opacity: 0, y: 24 },
  visible: { opacity: 1, y: 0, transition: { duration: 0.5, ease: [0.22, 1, 0.36, 1] } },
};
const stagger = { visible: { transition: { staggerChildren: 0.07 } } };

// ─── DEALER LIST (add real dealers here) ─────────────────────────────────────
const DEALERS = [
  // { id: 1, name: 'ABC Ford', city: 'Toronto', province: 'ON', leasing: true, financing: true, oem: 'Ford', logo: null, phone: '', website: '' },
  // Placeholder — populate when ready
];

const COMING_PLACEHOLDERS = [
  { oem: 'Ford', color: '#003478' },
  { oem: 'Toyota', color: '#EB0A1E' },
  { oem: 'Honda', color: '#CC0000' },
  { oem: 'GM', color: '#0169CE' },
  { oem: 'Hyundai', color: '#002C5F' },
  { oem: 'Kia', color: '#05141F' },
  { oem: 'Dodge', color: '#D0021B' },
  { oem: 'Jeep', color: '#1A5E1A' },
  { oem: 'BMW', color: '#1C69D4' },
  { oem: 'Mercedes', color: '#222222' },
  { oem: 'Audi', color: '#BB0A30' },
  { oem: 'Nissan', color: '#C3002F' },
];

export default function LeasingPage() {
  const [filter, setFilter] = useState('all');
  const [search, setSearch] = useState('');
  const [province, setProvince] = useState('');

  const provinces = ['AB', 'BC', 'MB', 'NB', 'NL', 'NS', 'ON', 'PE', 'QC', 'SK'];

  const filtered = DEALERS.filter(d => {
    if (filter === 'leasing' && !d.leasing) return false;
    if (filter === 'financing' && !d.financing) return false;
    if (province && d.province !== province) return false;
    if (
      search &&
      !d.name.toLowerCase().includes(search.toLowerCase()) &&
      !d.city.toLowerCase().includes(search.toLowerCase())
    )
      return false;
    return true;
  });

  return (
    <>
      <PageMeta
        path="/leasing-financing"
        title="Leasing & Financing from Certified Dealers"
        description="Explore leasing and financing options for new and used vehicles from certified dealers across Canada."
      />
      <div
        style={{
          fontFamily: 'DM Sans, sans-serif',
          color: c.text,
          background: c.white,
          minHeight: '100vh',
        }}
      >
        {/* HERO */}
        <section
          style={{
            background: 'linear-gradient(145deg, #060D17 0%, #0A1A2E 60%, #071420 100%)',
            padding: '100px 32px 80px',
            position: 'relative',
            overflow: 'hidden',
          }}
        >
          <div
            style={{
              position: 'absolute',
              top: '20%',
              left: '50%',
              transform: 'translateX(-50%)',
              width: 800,
              height: 400,
              background: 'radial-gradient(ellipse, rgba(26,158,133,0.1) 0%, transparent 70%)',
              pointerEvents: 'none',
            }}
          />
          <div
            style={{ maxWidth: 860, margin: '0 auto', textAlign: 'center', position: 'relative' }}
          >
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6 }}
            >
              <span
                style={{
                  display: 'inline-block',
                  background: 'rgba(26,158,133,0.15)',
                  border: '1px solid rgba(26,158,133,0.35)',
                  borderRadius: 20,
                  padding: '5px 16px',
                  fontSize: 11,
                  fontWeight: 700,
                  color: c.teal,
                  letterSpacing: '1.2px',
                  textTransform: 'uppercase',
                  marginBottom: 24,
                }}
              >
                Dealer Network
              </span>
              <h1
                style={{
                  fontSize: 'clamp(30px, 5vw, 56px)',
                  fontWeight: 900,
                  color: '#fff',
                  margin: '0 0 18px',
                  fontFamily: 'DM Sans, sans-serif',
                  lineHeight: 1.1,
                }}
              >
                Leasing & Financing
                <br />
                <span style={{ color: c.teal }}>from Certified Dealers</span>
              </h1>
              <p
                style={{
                  fontSize: 17,
                  color: 'rgba(255,255,255,0.55)',
                  maxWidth: 580,
                  margin: '0 auto 36px',
                  lineHeight: 1.75,
                }}
              >
                Browse licensed Canadian dealerships offering OEM leasing and structured financing —
                vetted and listed on SkipTheDealerships.ai.
              </p>
              <div style={{ display: 'flex', gap: 14, justifyContent: 'center', flexWrap: 'wrap' }}>
                <button
                  onClick={() => (window.location.href = '/l/new')}
                  style={{
                    padding: '14px 32px',
                    background: c.teal,
                    color: '#fff',
                    border: 'none',
                    borderRadius: 12,
                    fontWeight: 700,
                    fontSize: 15,
                    cursor: 'pointer',
                    fontFamily: 'DM Sans, sans-serif',
                    boxShadow: '0 4px 20px rgba(26,158,133,0.35)',
                  }}
                >
                  List Your Dealership
                </button>
                <button
                  onClick={() => (window.location.href = '/s')}
                  style={{
                    padding: '14px 32px',
                    background: 'rgba(255,255,255,0.07)',
                    color: '#fff',
                    border: '1px solid rgba(255,255,255,0.15)',
                    borderRadius: 12,
                    fontWeight: 700,
                    fontSize: 15,
                    cursor: 'pointer',
                    fontFamily: 'DM Sans, sans-serif',
                  }}
                >
                  Browse Vehicles
                </button>
              </div>
            </motion.div>
          </div>
        </section>

        {/* STATS BAR */}
        <section style={{ background: c.teal, padding: '20px 32px' }}>
          <div
            style={{
              maxWidth: 900,
              margin: '0 auto',
              display: 'flex',
              justifyContent: 'center',
              gap: 48,
              flexWrap: 'wrap',
            }}
          >
            {[
              { value: 'Coming Soon', label: 'Verified Dealers' },
              { value: '15+', label: 'Financing Partners' },
              { value: '0%', label: 'Lowest Lease Rate' },
              { value: '240 mo', label: 'Max Term (RV)' },
            ].map((s, i) => (
              <div key={i} style={{ textAlign: 'center' }}>
                <div
                  style={{
                    fontSize: 22,
                    fontWeight: 900,
                    color: '#fff',
                    fontFamily: 'DM Sans, sans-serif',
                  }}
                >
                  {s.value}
                </div>
                <div
                  style={{
                    fontSize: 11,
                    color: 'rgba(255,255,255,0.75)',
                    fontWeight: 600,
                    letterSpacing: '0.5px',
                    textTransform: 'uppercase',
                  }}
                >
                  {s.label}
                </div>
              </div>
            ))}
          </div>
        </section>

        {/* FILTERS */}
        <section
          style={{
            padding: '40px 32px 0',
            background: c.bg,
            borderBottom: `1px solid ${c.border}`,
          }}
        >
          <div style={{ maxWidth: 1100, margin: '0 auto' }}>
            <div
              style={{
                display: 'flex',
                gap: 12,
                flexWrap: 'wrap',
                alignItems: 'center',
                paddingBottom: 24,
              }}
            >
              <input
                placeholder="Search dealer or city…"
                value={search}
                onChange={e => setSearch(e.target.value)}
                style={{
                  flex: '1 1 220px',
                  padding: '11px 16px',
                  border: `1px solid ${c.border}`,
                  borderRadius: 10,
                  fontSize: 14,
                  fontFamily: 'DM Sans, sans-serif',
                  outline: 'none',
                  background: c.white,
                }}
              />
              <select
                value={province}
                onChange={e => setProvince(e.target.value)}
                style={{
                  padding: '11px 16px',
                  border: `1px solid ${c.border}`,
                  borderRadius: 10,
                  fontSize: 14,
                  fontFamily: 'DM Sans, sans-serif',
                  background: c.white,
                  outline: 'none',
                }}
              >
                <option value="">All Provinces</option>
                {provinces.map(p => (
                  <option key={p} value={p}>
                    {p}
                  </option>
                ))}
              </select>
              {['all', 'leasing', 'financing'].map(f => (
                <button
                  key={f}
                  onClick={() => setFilter(f)}
                  style={{
                    padding: '11px 22px',
                    borderRadius: 10,
                    fontSize: 13,
                    fontWeight: 700,
                    cursor: 'pointer',
                    fontFamily: 'DM Sans, sans-serif',
                    border: 'none',
                    transition: 'all 0.2s',
                    background: filter === f ? c.navy : c.white,
                    color: filter === f ? '#fff' : c.textMid,
                    boxShadow: filter === f ? 'none' : `0 1px 4px rgba(0,0,0,0.06)`,
                  }}
                >
                  {f === 'all' ? 'All Options' : f === 'leasing' ? '🔑 Leasing' : '💳 Financing'}
                </button>
              ))}
            </div>
          </div>
        </section>

        {/* DEALER GRID / EMPTY STATE */}
        <section style={{ padding: '60px 32px', background: c.bg, minHeight: 400 }}>
          <div style={{ maxWidth: 1100, margin: '0 auto' }}>
            {filtered.length > 0 ? (
              <div
                style={{
                  display: 'grid',
                  gridTemplateColumns: 'repeat(auto-fill, minmax(300px, 1fr))',
                  gap: 20,
                }}
              >
                {filtered.map(dealer => (
                  <motion.div
                    key={dealer.id}
                    initial="hidden"
                    animate="visible"
                    variants={fadeUp}
                    style={{
                      background: c.white,
                      border: `1px solid ${c.border}`,
                      borderRadius: 16,
                      padding: '24px',
                      boxShadow: '0 2px 12px rgba(15,32,51,0.05)',
                    }}
                  >
                    <div
                      style={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'flex-start',
                        marginBottom: 16,
                      }}
                    >
                      <div>
                        <div style={{ fontSize: 16, fontWeight: 700, color: c.navy }}>
                          {dealer.name}
                        </div>
                        <div style={{ fontSize: 13, color: c.textMid }}>
                          {dealer.city}, {dealer.province}
                        </div>
                      </div>
                      <div style={{ display: 'flex', gap: 6 }}>
                        {dealer.leasing && (
                          <span
                            style={{
                              background: c.tealLight,
                              border: `1px solid ${c.tealBorder}`,
                              borderRadius: 8,
                              padding: '3px 9px',
                              fontSize: 10,
                              fontWeight: 700,
                              color: c.teal,
                            }}
                          >
                            LEASE
                          </span>
                        )}
                        {dealer.financing && (
                          <span
                            style={{
                              background: 'rgba(15,32,51,0.07)',
                              border: '1px solid rgba(15,32,51,0.12)',
                              borderRadius: 8,
                              padding: '3px 9px',
                              fontSize: 10,
                              fontWeight: 700,
                              color: c.navy,
                            }}
                          >
                            FINANCE
                          </span>
                        )}
                      </div>
                    </div>
                    <div style={{ fontSize: 12, color: c.textLight, marginBottom: 16 }}>
                      {dealer.oem} Authorized Dealer
                    </div>
                    <button
                      style={{
                        width: '100%',
                        padding: '10px',
                        background: c.teal,
                        color: '#fff',
                        border: 'none',
                        borderRadius: 10,
                        fontWeight: 700,
                        fontSize: 13,
                        cursor: 'pointer',
                        fontFamily: 'DM Sans, sans-serif',
                      }}
                    >
                      View Inventory & Rates
                    </button>
                  </motion.div>
                ))}
              </div>
            ) : (
              /* EMPTY STATE — dealer list coming */
              <div style={{ textAlign: 'center', padding: '40px 0' }}>
                <motion.div initial="hidden" animate="visible" variants={stagger}>
                  <motion.div variants={fadeUp}>
                    <div style={{ fontSize: 48, marginBottom: 16 }}>🚘</div>
                    <h2
                      style={{
                        fontSize: 26,
                        fontWeight: 800,
                        color: c.navy,
                        margin: '0 0 12px',
                        fontFamily: 'DM Sans, sans-serif',
                      }}
                    >
                      Dealer roster loading…
                    </h2>
                    <p
                      style={{
                        fontSize: 15,
                        color: c.textMid,
                        maxWidth: 460,
                        margin: '0 auto 32px',
                        lineHeight: 1.7,
                      }}
                    >
                      We're onboarding licensed Canadian dealerships now. Be the first to list your
                      inventory and reach verified private buyers.
                    </p>
                  </motion.div>

                  {/* OEM BRAND PLACEHOLDERS */}
                  <motion.div variants={fadeUp}>
                    <p
                      style={{
                        fontSize: 12,
                        fontWeight: 700,
                        color: c.textLight,
                        letterSpacing: '1px',
                        textTransform: 'uppercase',
                        marginBottom: 20,
                      }}
                    >
                      Accepting dealers from all major brands
                    </p>
                    <div
                      style={{
                        display: 'flex',
                        gap: 12,
                        justifyContent: 'center',
                        flexWrap: 'wrap',
                        marginBottom: 40,
                      }}
                    >
                      {COMING_PLACEHOLDERS.map((b, i) => (
                        <div
                          key={i}
                          style={{
                            background: c.white,
                            border: `1px solid ${c.border}`,
                            borderRadius: 12,
                            padding: '12px 20px',
                            fontSize: 13,
                            fontWeight: 700,
                            color: b.color,
                            boxShadow: '0 1px 6px rgba(0,0,0,0.05)',
                            minWidth: 80,
                            textAlign: 'center',
                          }}
                        >
                          {b.oem}
                        </div>
                      ))}
                    </div>
                  </motion.div>

                  {/* CTA */}
                  <motion.div
                    variants={fadeUp}
                    style={{ display: 'flex', gap: 14, justifyContent: 'center', flexWrap: 'wrap' }}
                  >
                    <button
                      onClick={() => (window.location.href = '/l/new')}
                      style={{
                        padding: '14px 32px',
                        background: c.teal,
                        color: '#fff',
                        border: 'none',
                        borderRadius: 12,
                        fontWeight: 700,
                        fontSize: 15,
                        cursor: 'pointer',
                        fontFamily: 'DM Sans, sans-serif',
                        boxShadow: '0 4px 20px rgba(26,158,133,0.3)',
                      }}
                    >
                      List Your Dealership — It's Free
                    </button>
                    <button
                      onClick={() => (window.location.href = '/')}
                      style={{
                        padding: '14px 32px',
                        background: c.white,
                        color: c.navy,
                        border: `1px solid ${c.border}`,
                        borderRadius: 12,
                        fontWeight: 700,
                        fontSize: 15,
                        cursor: 'pointer',
                        fontFamily: 'DM Sans, sans-serif',
                      }}
                    >
                      Back to Marketplace
                    </button>
                  </motion.div>
                </motion.div>
              </div>
            )}
          </div>
        </section>

        {/* LEASING VS FINANCING EXPLAINER */}
        <section style={{ padding: '80px 32px', background: c.white }}>
          <div style={{ maxWidth: 900, margin: '0 auto' }}>
            <div style={{ textAlign: 'center', marginBottom: 48 }}>
              <h2
                style={{
                  fontSize: 'clamp(22px, 3vw, 36px)',
                  fontWeight: 800,
                  color: c.navy,
                  margin: '0 0 12px',
                  fontFamily: 'DM Sans, sans-serif',
                }}
              >
                Lease or Finance — what's right for you?
              </h2>
              <p
                style={{
                  fontSize: 15,
                  color: c.textMid,
                  maxWidth: 500,
                  margin: '0 auto',
                  lineHeight: 1.7,
                }}
              >
                Our AI matches buyers to the right structure based on their credit profile and
                vehicle preference.
              </p>
            </div>
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 24 }}>
              {[
                {
                  title: '🔑 Vehicle Leasing',
                  color: c.teal,
                  points: [
                    'Lower monthly payments',
                    'Drive a new vehicle every 2–4 years',
                    'OEM warranty covers the full term',
                    'Mileage limits apply (typically 20,000 km/yr)',
                    'No equity — return or buyout at end',
                    'Rates from 0% on select new models',
                  ],
                },
                {
                  title: '💳 Vehicle Financing',
                  color: c.navy,
                  points: [
                    'Build equity with every payment',
                    'No mileage restrictions',
                    'Modify or sell the vehicle anytime',
                    'Own outright at end of term',
                    'New & used vehicles eligible',
                    'Rates from 2.99% — 15+ lenders',
                  ],
                },
              ].map((col, i) => (
                <div
                  key={i}
                  style={{
                    background: c.bg,
                    border: `1px solid ${c.border}`,
                    borderRadius: 16,
                    padding: '28px 28px',
                  }}
                >
                  <div
                    style={{
                      fontSize: 18,
                      fontWeight: 800,
                      color: col.color,
                      marginBottom: 20,
                      fontFamily: 'DM Sans, sans-serif',
                    }}
                  >
                    {col.title}
                  </div>
                  <ul style={{ listStyle: 'none', padding: 0, margin: 0 }}>
                    {col.points.map((p, j) => (
                      <li
                        key={j}
                        style={{
                          display: 'flex',
                          gap: 10,
                          alignItems: 'flex-start',
                          marginBottom: 12,
                          fontSize: 14,
                          color: c.text,
                          lineHeight: 1.5,
                        }}
                      >
                        <span style={{ color: col.color, fontWeight: 700, marginTop: 1 }}>✓</span>
                        {p}
                      </li>
                    ))}
                  </ul>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* FOOTER CTA */}
        <section style={{ padding: '60px 32px', background: c.navy, textAlign: 'center' }}>
          <div style={{ maxWidth: 600, margin: '0 auto' }}>
            <h2
              style={{
                fontSize: 28,
                fontWeight: 800,
                color: '#fff',
                margin: '0 0 14px',
                fontFamily: 'DM Sans, sans-serif',
              }}
            >
              Are you a dealer?
            </h2>
            <p
              style={{
                color: 'rgba(255,255,255,0.55)',
                fontSize: 15,
                marginBottom: 28,
                lineHeight: 1.7,
              }}
            >
              List your inventory, leasing specials, and financing programs on
              SkipTheDealerships.ai. Reach pre-qualified, KYC-verified buyers across Canada.
            </p>
            <button
              onClick={() => (window.location.href = '/l/new')}
              style={{
                padding: '15px 36px',
                background: c.teal,
                color: '#fff',
                border: 'none',
                borderRadius: 12,
                fontWeight: 700,
                fontSize: 16,
                cursor: 'pointer',
                fontFamily: 'DM Sans, sans-serif',
                boxShadow: '0 4px 20px rgba(26,158,133,0.4)',
              }}
            >
              Join the Dealer Network
            </button>
          </div>
        </section>
      </div>
    </>
  );
}
